export type SessionDetails = {
  applicationUserID: string;
  mobileVersion: string;
  fullName: string;
  salt: string;
  userType: string;
  roleIDs: string[];
  companyID: string;
  companySiteID: string;
  wrHouseID: string;
  salesPersonID: string;
  deviceName: string;
  id: string;
  userID: string;
  userName: string;
  dbName: string;
  isAdmin: boolean;
  isMobile: boolean;
  requests: number;
  aliveTime: string;
  topRows: number;
  loginTime: string;
  lastAlive: string;
};

export type SelectDropdownItem = {
  value: number | string;
  name: string;
  displayName?: string;
};

export type UserPreference = {
  id: string;
  designation: string;
  preferenceContent: string;
  userID: string;
  isDefault: boolean;
  preferenceType: 'Favorites save' | 'Filter save' | 'Layout save';
  rowVersion: string;
  rowStatus: 'Added' | 'Modified' | 'Deleted';
  isActive: boolean;
  isFromManager: boolean;
  createUserID: string;
};

export type TableFilterData = {
  query?: string;
  page?: number;
  column?: number;
  order?: 'asc' | 'desc';
  itemsPerPage?: number;
  sortColumn?: string;
  sortAscending?: boolean;
  excludeIDs?: string[];
  filter?: any;
  isActive?: boolean;
};

export type TableColumn = {
  value: string;
  text: string;
  type?: string;
  active?: boolean;
};

export type BaseObject = {
  id: string;
  createdDate?: string;
  lastUpdate?: string;
  createUserId?: string;
  updateUserId?: string;
  isActive?: boolean;
  isFromManager?: boolean;
  boid?: string;
  exportedDate?: string;
  deleted?: boolean;
  rowVersion?: string;
};

export type BaseProperty = {
  id: string;
  name?: string;
  description?: string;
  code?: string;
};

export enum RecordMode {
  Unchanged = 0,
  Added,
  Modified,
  Deleted,
  ViewOnly,
  Restored,
}

export type GroupCategory = 'material' | 'traderSite' | 'alterCode' | 'customer' | '';

export type QueryParams = {
  page?: number;
  itemsPerPage: number;
  query?: string;
  sortColumn?: string;
  sortAscending?: boolean;
  isActive?: boolean;
};

export type TableSelectedPage = {
  tableId: string;
  page: number;
  itemsPerPage: number;
};
